$(document).ready(function(){
//     $(document).on("click", ".check_availability", function() {
//         // Pull data directly from the clicked button's data attributes
//         var sku = $(this).attr("data-sku");
//         var p_image = $(this).attr("data-image");
        
//         console.log("Checking SKU: " + sku);
        
//         $("#result_store").html("<div class='loader-icon'><img src='https://cdn.shopify.com/s/files/1/0480/8867/8558/files/loader1.gif?v=1771412506'></div>");
        
//         var url = "https://shop.ragesa.co.za/ragesa/xmlread/mapstock.php";
//         // var proxy = 'https://test.cors.workers.dev/?';

// var proxy = 'https://corsproxy.io/?url=';
        
//         // Use the dynamic variables captured above
//         var str = 'sku=' + sku + '&image=' + p_image + '&category={{ my_variable }}';

//         setTimeout(function(){
//             $.ajax({
//                 type: "POST",
//                 url: proxy + url,
//                 data: str,
//                 success: SuccessOccur,
//                 crossDomain: true, 
//                 headers: {
//                     "accept": "application/json",
//                     "Access-Control-Allow-Origin":"*"
//                 }
//             });
//         }, 100); // Reduced timeout for better UX
//     });

$(document).on("click", ".check_availability", function () {
    const sku = $(this).data("sku");
    let p_image = $(this).data("image");

    try {
        p_image = decodeURIComponent(p_image);
    } catch {}

    const category = "default";

    const baseUrl = "https://webappsitesdemo.com/xmlread/mapstock.php?sku=A6SLXEV08APBL030&image=https://ragesa.co.za/cdn/shop/files/A6SLXEV08APBL_6192fd9f-bb24-40ae-a19f-7bd014bfbc71_2048x.png?v=1781158865&category=default";

    const fullUrl = `${baseUrl}?sku=${encodeURIComponent(sku)}&image=${encodeURIComponent(p_image)}&category=${encodeURIComponent(category)}`;

    // const proxyUrl = "https://corsproxy.io/?url=" + encodeURIComponent(fullUrl);
    // const proxyUrl = encodeURIComponent(fullUrl);

    // console.log("FINAL URL:", proxyUrl);

    $.ajax({
        url: fullUrl,
        type: "GET",
        success: function (data) {
            $(".ajax-data").html(data);
        },
        error: function (xhr, status, error) {
            console.log(error);
        }
    });
});

    function SuccessOccur(data, status, req) {
    if (status == "success") {
        $(".ajax-data").html(data);

        $(".ajax-data").find("script").each(function() {
            $.globalEval(this.innerHTML);
        });
    }
}
});


(function() {
            var script = document.createElement('script');
            script.src = "https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js";
            script.onload = function() {
                var bsjQuery = jQuery.noConflict(true); // detach from global $
                var bootstrapScript = document.createElement('script');
                bootstrapScript.src = "https://maxcdn.bootstrapcdn.com/bootstrap/3.4.1/js/bootstrap.min.js";
                bootstrapScript.onload = function() {
                    // Attach bootstrap to isolated jQuery
                    window.bootstrapJQ = bsjQuery;
                };
                document.body.appendChild(bootstrapScript);
            };
            document.body.appendChild(script);
})();

